<template>
    <div class="row match-height">
        <!-- <div class="col col-12"> -->
            <!-- <div class="row match-height">s -->
                <!-- Bar Chart - Orders -->
                <!-- <div class="col-lg-6 col-md-3 col-6">
                    <family-user :data="staticFamily"></family-user>
                </div> -->
                <!--/ Bar Chart - Orders -->

                <!-- Line Chart - Profit -->
                <!-- <div class="col-lg-6 col-md-3 col-6">
                    <self-user :data="staticSelf"></self-user>
                </div> -->
                <!--/ Line Chart - Profit -->

                <!-- Earnings Card -->
                <div class="col-lg-12">

                    <monthly-signup-stats></monthly-signup-stats>
                </div>
                <!--/ Earnings Card -->
            <!-- </div> -->
        <!-- </div> -->

        <!-- <yearly-earnings-component :data="revenue"></yearly-earnings-component> -->
    </div>


    <active-report></active-report>
</template>
<script>
import ActiveReport from './ActiveReport.vue'
import MonthlySignupStats from './MonthlySignupStats.vue'
import FamilyUser from './earnings/FamilyUser.vue'
import SelfUser from './earnings/SelfUser.vue'
import YearlyEarningsComponent from './earnings/yearlyEarningsComponent.vue'
export default {
  components: { FamilyUser, SelfUser, MonthlySignupStats, ActiveReport, YearlyEarningsComponent },
    name:'MonthlyEarnings',

    data(){
        return{
            // staticFamily:{
            //     series: [
            //         {
            //             name: '2020',
            //             data: [45, 85, 65, 45, 65],
            //         },
            //     ],
            // },
            // staticSelf:{
            //     series: [
            //         {
            //             data: [0, 20, 5, 30, 15, 45],
            //         },
            //     ],
            // },
            // earningsChart: {
            //
            // },
            // revenue: {
            //     years: [2020, 2019, 2018],
            //     price: '25,852',
            //     budget: '56,800',
            //     budgetChart: {
            //         series: [
            //             {
            //             data: [61, 48, 69, 52, 60, 40, 79, 60, 59, 43, 62],
            //             },
            //             {
            //             data: [20, 10, 30, 15, 23, 0, 25, 15, 20, 5, 27],
            //             },
            //         ],
            //     },
            // },
        }
    }
}
</script>
